import axios from 'axios';
import moment from 'moment';
import { checkImageType, getImageType } from '../../../utils/CheckImageType';
import { TYPE_CONSTANT } from '../../../constant/Web_constant';
import { Listing_text } from '../../../constant/Translation/Listing';

export function getThumbnailImage(file, isThumb512 = false) {
  const file_check = file ? file : TYPE_CONSTANT.DEFAULT_IMAGE;
  let filename = file_check.split('/').pop();
  let fileURl = file_check.replace(
    filename,
    isThumb512 ? 'thumb512_' : 'thumb_' + filename
  );

  return checkImageType({ current_type: getImageType({ url: file }) })
    ? fileURl
    : file_check;
}

export function getThumbnailImage2(file) {
  let filename = file.split('/').pop();
  let fileURl = file.replace(filename, 'thumb_' + filename);

  return axios
    .get(fileURl)
    .then((res) => {
      return fileURl;
    })
    .catch((error) => {
      return file;
    });
}

export const changeDateFormat = (timestamp, format) => {
  const date = new Date(timestamp * 1000);
  return moment(date).format(format);
};

export function getDatesArray(date = new Date()) {
  let startDate = date ? new Date(date) : new Date();
  var stopDate = new Date(startDate);
  stopDate.setDate(stopDate.getDate() + 30);
  var dateArray = [];
  var currentDate = startDate;

  for (let index = 0; index < 30; index++) {
    dateArray.push(new Date(currentDate));
    currentDate = startDate.setDate(startDate.getDate() + 1);
  }

  return dateArray;
}

export function getDatesArray2() {
  let startDate = new Date();
  var stopDate = new Date();
  stopDate.setDate(stopDate.getDate() + 30);
  var dateArray = ['All'];
  var currentDate = startDate;

  for (let index = 0; index < 30; index++) {
    dateArray.push(new Date(currentDate));
    currentDate = startDate.setDate(startDate.getDate() + 1);
  }

  return dateArray;
}

export function getTimeDifference(sTime, etime) {
  var mm = moment.utc(moment(etime, 'HH:mm').diff(moment(sTime, 'HH:mm')));
  var d = moment.duration(mm);
  let min = d.asMinutes();
  return min;
}

export const repeatArray = [
  { name: Listing_text.producttime.daily, id: '1,2,3,4,5,6,7' },
  { name: Listing_text.producttime.weekdays, id: '2,3,4,5,6' },
  { name: Listing_text.producttime.weekend, id: '1,7' },
  { name: Listing_text.producttime.custom, id: 'custom' },
];

export const weekDays = [
  { name: Listing_text.producttime.sun, id: 1 },
  { name: Listing_text.producttime.mon, id: 2 },
  { name: Listing_text.producttime.tue, id: 3 },
  { name: Listing_text.producttime.wed, id: 4 },
  { name: Listing_text.producttime.thu, id: 5 },
  { name: Listing_text.producttime.fri, id: 6 },
  { name: Listing_text.producttime.sat, id: 7 },
];

export function convertTimeinto24Hrs(time) {
  const number = moment(time, ['h:mm A']).format('HH:mm');
  return number;
}
export function convertTimeinto12Hrs(time) {
  const number = moment(time, ['HH:mm']).format('hh:mm A');
  return number;
}

export const findRepeatId = (value, id) => {
  const convert = value?.toString();
  const find = repeatArray.filter((item) => item.id === `${convert}`);
  if (find.length > 0) {
    return find[0];
  } else {
    // const dayname = value.map((day) => {
    //   for (let index = 0; index < weekDays.length; index++) {
    //     const element = weekDays[index];
    //     if (day === element.id) {
    //       return element.name;
    //     }
    //   }
    // });

    return repeatArray[3];
  }
};

export const findRepeatName = (value) => {
  const convert = value.toString();
  const find = repeatArray.filter((item) => item.id === `${convert}`);
  if (find.length > 0) {
    return find[0].name;
  } else {
    const dayname = value.map((day) => {
      for (let index = 0; index < weekDays.length; index++) {
        const element = weekDays[index];
        if (day === element.id) {
          return element.name;
        }
      }
    });

    return `Custom(${dayname.toString()})`;
  }
};

export const priceRange = [
  { value: 'relevance', label: 'Relevance' },
  { value: 'price_low_to_high', label: 'Price low to high' },
  { value: 'price_high_to_low', label: 'Price high to low' },
  { value: 'newest_first', label: 'Newest first' },
];

// relative time
export const get_relative_time = (timestamp) => {
  return moment(
    moment.unix(timestamp).format('YYYYMMDD'),
    'YYYYMMDD'
  ).fromNow();
};

// convert timn to epoch format
export function dateToEpochInSeconds(dateString) {
  const momentDate = moment(dateString, 'YYYY-MM-DD HH:mm:ss');
  const jsDate = momentDate.toDate();
  const epochSeconds = Math.floor(jsDate.getTime() / 1000);
  return epochSeconds;
}
